import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import user from './modules/user';
import dic from './modules/dic';
import commonInfo from './modules/commonInfo';
Vue.use(Vuex);
var state = {
  errMsg: null,
  isCollapse: false // 菜单是否折叠

};
export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  modules: {
    dic: dic,
    user: user,
    commonInfo: commonInfo
  }
});